import { fieldTypeOf } from '../field-types';
import type { FieldElement, FormDefinition } from '../format/form-definition';
import type { Validation } from '../format/pieces';
import { sayBound } from './range';
import { requiredText } from './required';
import { uniqueText } from './unique';
import { USER_PLACEHOLDERS } from '../texts/userPlaceholders';

export const defaultText = (definition: FormDefinition, field: FieldElement, validation: Validation): string => {
  const { valueKind } = fieldTypeOf(field);
  switch (validation.kind) {
    case 'required':
      return requiredText(valueKind);
    case 'range': {
      return (['min', 'max'] as const)
        .flatMap(end => {
          const bound = validation[end];
          return bound === undefined ? [] : USER_PLACEHOLDERS.range.byKind[valueKind][end](sayBound(definition, bound));
        })
        .join(' · ');
    }
    case 'unique':
      return uniqueText(valueKind, 1);
    case 'pattern':
      return USER_PLACEHOLDERS.pattern.invalid;
    default:
      return validation satisfies never;
  }
};
